import { DropdownMenuBaseController } from "./dropdown_menu_base_controller";

export default class ChipDropdownController extends DropdownMenuBaseController {
  static targets = ["trigger", "label", "icon", "menu", "menuItem", "itemIcon", "itemHint"];
  static values = { selected: String };

  connect() {
    this._confirmCancelHandler = this._onConfirmCancel.bind(this);
    document.addEventListener("promote:confirm-cancel", this._confirmCancelHandler);
  }

  disconnect() {
    document.removeEventListener("promote:confirm-cancel", this._confirmCancelHandler);
  }

  toggle() {
    if (this.menuTarget.classList.contains("hidden")) {
      this._openMenu();
    } else {
      this.closeMenu();
    }
  }

  select(event) {
    const item = event.currentTarget;
    const value = item.dataset.value;

    if (item.dataset.confirm) {
      this._previousState = this._captureState();
    }

    this._deselectItems();
    this._selectItem(item);

    this.labelTarget.textContent = item.dataset.text;
    this.selectedValue = value;

    this.itemIconTargets.forEach(icon => {
      icon.classList.toggle("hidden", icon.dataset.value !== value);
    });

    if (this.hasItemHintTarget) {
      this.itemHintTargets.forEach(hint => {
        hint.classList.toggle("hidden", hint.dataset.value !== value);
      });
    }

    this.closeMenu();
  }

  closeMenu() {
    this.menuTarget.classList.add("hidden");
    this.iconTarget.classList.remove("rotate-180");
    this.triggerTarget.classList.remove("open");
    document.removeEventListener("click", this.clickOutsideHandler);
  }

  _openMenu() {
    this.menuTarget.classList.remove("hidden");
    this.iconTarget.classList.add("rotate-180");
    this.triggerTarget.classList.add("open");
    document.addEventListener("click", this.clickOutsideHandler);
  }

  _captureState() {
    return {
      label: this.labelTarget.textContent,
      selectedValue: this.selectedValue,
      selectedItems: this.menuItemTargets.map(el => ({
        el,
        selected: el.classList.contains("selected")
      })),
      iconVisibility: this.itemIconTargets.map(el => ({
        el,
        hidden: el.classList.contains("hidden")
      })),
      hintVisibility: this.hasItemHintTarget
        ? this.itemHintTargets.map(el => ({ el, hidden: el.classList.contains("hidden") }))
        : []
    };
  }

  _onConfirmCancel(event) {
    if (!this._previousState) return;
    if (!this.element.contains(event.detail.element)) return;

    const state = this._previousState;
    this._previousState = null;

    this.labelTarget.textContent = state.label;
    this.selectedValue = state.selectedValue;
    state.selectedItems.forEach(({ el, selected }) => {
      el.classList.toggle("selected", selected);
    });
    state.iconVisibility.forEach(({ el, hidden }) => {
      el.classList.toggle("hidden", hidden);
    });
    state.hintVisibility.forEach(({ el, hidden }) => {
      el.classList.toggle("hidden", hidden);
    });
  }
}
